// extracted by mini-css-extract-plugin
module.exports = {"employee":"Employee_employee__uHnsY","employeeName":"Employee_employeeName__25MYS","countShifts":"Employee_countShifts__1oTFz"};